import {
  ListingRoundedImage,
  ListingRoundedImageProps,
} from "../listingRoundedImage/ListingRoundedImage";
import React from "react";
import { cn } from "../../../../helpers/cn";

type ListingSmallImageProps = ListingRoundedImageProps;

export const ListingSmallImage = ({
  image,
  title,
  className,
  ...props
}: ListingSmallImageProps) => {
  return (
    <ListingRoundedImage
      className={cn("w-[72px] h-[72px] sm:w-[96px] sm:h-[96px]", className)}
      image={image}
      title={title}
      {...props}
    />
  );
};
